import CityPageTemplate from "../city-template/CityPageTemplate";
import { murrayConfig } from "./data";

export default function MurrayPage() {
  return <CityPageTemplate config={murrayConfig} />;
}